export class CustomError extends Error {
  code: string;

  constructor(code: string, message?: string) {
    super(message ?? code); // fall back to code for readable stacks
    this.name = code;
    this.code = code;
  }
}
